import React, { FC } from 'react';
import ListMeRepositories from '../../components/core/ListMeRepositories/ListMeRepositories';
import ListRepositories from '../../components/core/ListRepositories/ListRepositories';
import ModalAccess from '../../components/core/Modal-Access/Modal-Access';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';


import './PortalDocumentsMeRepositories';

interface PortalDocumentsMeRepositoriesProps {}
const PortalDocumentsMeRepositories: FC<PortalDocumentsMeRepositoriesProps> = () => {
    return(
    <div>
          <PrimaryNavigation />
          <div className="PortalDocumentsMeRepositories">
          <div className="table-container">
          <ListMeRepositories></ListMeRepositories>
          </div>
      </div>
      </div>);
  }

export default PortalDocumentsMeRepositories;
